var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "prices u-row" }, [
    _c("div", { staticClass: "info" }, [
      _c("p", { staticClass: "label u-row" }, [
        _c("span", [_vm._v("平均成約価格：")]),
        _vm._v(" "),
        _c("span", { staticClass: "t15 w7" }, [
          _vm._v(_vm._s(_vm._f("price")(_vm.data.averageDealPrice)))
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "label u-row" }, [
        _c("span", [_vm._v("平均坪単価：")]),
        _vm._v(" "),
        _c("span", { staticClass: "t15 w7" }, [
          _vm._v(
            _vm._s(_vm._f("price")(_vm.data.averageDealPriceBySqm * _vm.tsubo))
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend u-row" }, [
      _c("i", { staticClass: "cl-blue" }),
      _vm._v(" "),
      _c("p", [_vm._v("平均成約価格")]),
      _vm._v(" "),
      _c("i", { staticClass: "cl-orange" }),
      _vm._v(" "),
      _c("p", [_vm._v("平均坪単価")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }